import { combineReducers } from 'redux';
import { jobTableDataReducer } from './tableDataReducer';
import { jobTableFilterReducer } from './tableFilterReducer';
import { jobTableSortReducer } from './tableSortReducer';
import { jobTablePaginationReducer } from './tablePaginationReducer';
import { jobTableSearchReducer } from './tableSearchReducer';
import { jobCreationReducer } from './creationTakeoverReducer';

export const jobManagerReducer = combineReducers({
  tableData: jobTableDataReducer,
  tableFilters: jobTableFilterReducer,
  tableSort: jobTableSortReducer,
  tablePagination: jobTablePaginationReducer,
  tableSearch: jobTableSearchReducer,
  creationTakeover: jobCreationReducer,
});
